import{createElement as e}from"../../../external/preact/dist/preact.js";const r=({to:r,children:t})=>e("a",{className:"adyen-checkout-link",href:r,target:"_blank",rel:"noopener noreferrer"},t);export{r as default};
